/**
 * 利用ガイドの目次定義。
 *
 * サイドバーと URL ルーティングの単一の真実の源（single source of truth）。
 * 新しい記事を追加するときは:
 *  1. articles/ に <slug>.tsx を追加
 *  2. articles/index.ts に登録
 *  3. ここの TOC_SECTIONS に追加
 */

export interface GuideArticleRef {
  slug: string;
  title: string;
}

export interface GuideSection {
  id: string;
  title: string;
  articles: GuideArticleRef[];
}

export const TOC_SECTIONS: GuideSection[] = [
  {
    id: "intro",
    title: "はじめに",
    articles: [
      { slug: "overview", title: "Sign Extension とは" },
    ],
  },
  {
    id: "start",
    title: "スタートガイド",
    articles: [
      { slug: "quick-start", title: "クイックスタート" },
      { slug: "hubspot-connect", title: "HubSpot との接続" },
      { slug: "cs-clientid", title: "クラウドサイン Client ID 登録" },
      { slug: "property-setup", title: "HubSpot プロパティ設定" },
    ],
  },
  {
    id: "features",
    title: "機能別ガイド",
    articles: [
      { slug: "send", title: "書類を送信する" },
      { slug: "templates", title: "テンプレートを使った送信" },
      { slug: "recipients", title: "固定送付宛先・共有先（CC）" },
      { slug: "status-sync", title: "ステータス自動連携" },
      { slug: "clientid-mgmt", title: "Client ID 管理（複数送信者）" },
      { slug: "notifications", title: "お知らせ・ベル通知" },
      { slug: "send-logs", title: "送信履歴" },
      { slug: "billing", title: "料金・プラン変更" },
    ],
  },
  {
    id: "admin",
    title: "管理者向けガイド",
    articles: [
      { slug: "users-roles", title: "ユーザー招待・権限管理" },
      { slug: "hubspot-reauth", title: "HubSpot 再認可" },
      { slug: "bulk-properties", title: "プロパティの一括作成" },
      { slug: "usage-limits", title: "送信上限と請求" },
    ],
  },
  {
    id: "faq",
    title: "よくある質問",
    articles: [
      { slug: "faq", title: "FAQ" },
    ],
  },
];

/** slug から該当記事のセクションと記事を取得 */
export function findArticle(slug: string): { section: GuideSection; article: GuideArticleRef } | null {
  for (const section of TOC_SECTIONS) {
    const article = section.articles.find((a) => a.slug === slug);
    if (article) return { section, article };
  }
  return null;
}

/** 全記事をフラットに並べる（前後ナビ用） */
export function flattenArticles(): GuideArticleRef[] {
  return TOC_SECTIONS.flatMap((s) => s.articles);
}
